import React, {  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";

function PrizeCalculator() {

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Calculador de Premios</h1>
      <Footer />
    </div>
  );
}

export default PrizeCalculator;
